import React from "react";

import { useNoteService } from "components/tables/notes";
import { NoteService } from "types";

import { NoteListModal } from "..";

type ViewNotesModalProps = {
	show: boolean;
	onHide: () => void;
	title?: string;
	entityId: string;
	value: string;
	service: NoteService;
};

export const ViewNotesModal = ({
	show,
	onHide,
	title = "Deal Notes",
	value,
	service,
	entityId,
}: ViewNotesModalProps) => {
	//Paging works only if useNoteListQuery and useNoteListQuery defined in one file. Because of closure
	const { useNoteListQuery } = useNoteService({
		key: value,
		service,
	});

	const { data, isFetching, page, setPage } = useNoteListQuery({
		entityId,
	});

	const handlePageChange = page => setPage(page - 1);

	return !isFetching ? (
		<NoteListModal
			show={show}
			onHide={onHide}
			title={title}
			notes={data?.items ?? []}
			loading={isFetching}
			page={page ?? 0}
			count={data?.count ?? 0}
			handlePageChange={handlePageChange}
		/>
	) : null;
};
